









import { Component, Vue } from 'vue-property-decorator';
import CartItem from '@/components/Cart/Item.vue';
import { CartItem as CartItemModel } from '@/store/models';
import cart from '@/store/modules/cart';

@Component({
  components: {
    CartItem,
  },
})
export default class CartSummaryDetails extends Vue {

  get items(): CartItemModel[] {
    return cart.cart.items;
  }

  get isGift(): boolean {
    return cart.isGiftcardCart;
  }

  private isInDiscount(item: CartItemModel): boolean {
    return item.price < item.extension_attributes.extoriginal_price;
  }
}
